// extracted by mini-css-extract-plugin
export default {"communityEditsList":"CommunityEditsList_communityEditsList__mAO2w","loadMoreButton":"CommunityEditsList_loadMoreButton__3uhiw","textArea":"CommunityEditsList_textArea__QIaaz"};